import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../Common/ui-components/Button';

const Advanced = ({ isEditOpen, setIsEditOpen, globalContext, rsImportance, setRsImportance, rsShowType }) => {
    const { t, i18n } = useTranslation();
    return (
        <div className={`adaptiveGrid rs-advanced`}>
            {rsImportance.map((item, i) => {
                // const update = (e) => {
                //     e.stopPropagation();
                //     const newItem = { ...item };
                //     newItem.checked = !item.checked;
                //     const newRsImportance = [...rsImportance];
                //     newRsImportance[i] = newItem;
                //     setRsImportance(newRsImportance);
                // };
                return (
                    <div
                        key={i}
                        className={`adaptiveGrid-item ${item.value > 0 ? 'adaptiveGrid-item-checked' : ''}`}
                        // onClick={update}
                        onClick={() => setIsEditOpen(true)}
                    >
                        <div className={`adaptiveGrid-item-up`}>
                            <span>{item.title}</span>
                        </div>
                        <div className={`adaptiveGrid-item-down Advanced-item`}>
                            <span className="Advanced-item-value">{item.value}</span>
                            <div
                                style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/img/' + item.className})` }}
                                className={`adaptiveGrid-item-right`}
                            ></div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
export default Advanced;
